import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FormPage from "./pages/FormPage";
import Form135 from "./pages/Form135";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import History from "./pages/History";
import FormSelector from "./pages/FormSelector";
import SimpleFormPage from "./pages/SimpleFormPage";
import UnifiedFormPage from "./pages/UnifiedFormPage";
import LextriaImport from "./pages/LextriaImport";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";
import { PrefillProvider } from "./context/PrefillContext";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        <div className="flex-1 flex flex-col">
          <PrefillProvider>
          <Routes>
            <Route path="/" element={<ProtectedRoute><LandingPage /></ProtectedRoute>} />
            <Route path="/formpage" element={<ProtectedRoute><FormPage /></ProtectedRoute>} />
            <Route path="/form135" element={<ProtectedRoute><Form135 /></ProtectedRoute>} />
            <Route path="/form-selector" element={<ProtectedRoute><FormSelector /></ProtectedRoute>} />
            <Route path="/form/:formNumber" element={<ProtectedRoute><SimpleFormPage /></ProtectedRoute>} />
            <Route path="/unified-form" element={<ProtectedRoute><UnifiedFormPage /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/import" element={<ProtectedRoute><LextriaImport /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </PrefillProvider>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
